import { render, staticRenderFns } from "./InquiryMessage.vue?vue&type=template&id=63210072&scoped=true&"
import script from "./InquiryMessage.vue?vue&type=script&lang=js&"
export * from "./InquiryMessage.vue?vue&type=script&lang=js&"
import style0 from "./InquiryMessage.vue?vue&type=style&index=0&id=63210072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63210072",
  null
  
)

export default component.exports